import React,{useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { PackingItemsContainer } from './packing-items.container';
import { Container } from '@material-ui/core';
import { DashboardStyles } from '../../hooks/styles';
import {Constants} from "../../constants/Constants";
const PackingItems = () => {
  const classes = DashboardStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage title={Constants.PAGE_TITLE.PACKING_ITEMS}>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <PackingItemsContainer />
      </Container>
    </BasePage>
  )
}

export default PackingItems;